import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";

import { getRevenusParMois } from "../services/LoginService";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const RevenusParMois = ({ year }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchRevenus() {
            setLoading(true);
            try {
                const token = localStorage.getItem("authTokenUtilisateur"); // ou Redux
                const res = await getRevenusParMois(token, year);
                if (res.success) {
                    setData(res.revenus);
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }

        fetchRevenus();
    }, [year]);

    const chartData = {
        labels: data.map((d) => d.month),
        datasets: [
            {
                label: "CA (€)",
                data: data.map((d) => d.value),
                backgroundColor: "#1A2A6C",
                barPercentage: 0.3,
                categoryPercentage: 0.8,
                borderRadius: 18,
                borderSkipped: false,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: true, position: "top" },
            title: { display: false, text: "CA par mois" },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.parsed.y} €`,
                },
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                title: { display: true, text: "CA (€)" },
            },
            x: {
                title: { display: true, text: "Mois" },
            },
        },
    };

    return (
        <div style={{ width: "80%", height: "300px", margin: "0 auto", position: "relative" }}>
            {loading && (
                <div className="absolute inset-0 bg-white bg-opacity-75 flex justify-center items-center z-50 rounded-lg">
                </div>
            )}
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default RevenusParMois;
